import React, { useEffect, useState } from 'react';
import axios from 'axios';
import styles from './style.module.css';

// import { faCirclePlus } from '@fortawesome/free-solid-svg-icons';

import { receivingWaterBodyApi, waterSourceApi } from '../../../configs';
import { Button, LoadingSpinner } from '../../elements';
import WaterModal from '../WaterModal';
import AccordionFieldGroup from '../AccordionFieldGroup/AccordionFieldGroup.component';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

export default function WaterCategoryContent(props) {
  const {
    // mandatory props
    /*  
      categoryId => 98 = Water Source, 99 = Receiving Water Body
    */
    categoryId,
    siteId,
    loading,
    setLoading,
    inputListSliced,
  } = props;
  const navigate = useNavigate();

  const [waterData, setWaterData] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [infoPopupShow, setinfoPopupShow] = useState(false);
  const [postLoading, setPostLoading] = useState(false);
  console.log('water data', waterData);

  const sourceFetchWaterComp = axios.CancelToken.source();

  // change water source API if already made
  const fetchApiused =
    categoryId === 98 ? waterSourceApi : receivingWaterBodyApi;

  function fetchWaterData(sourceFetchWater) {
    setLoading(true);

    axios
      .get(`${fetchApiused}/${siteId}`, {
        cancelToken: sourceFetchWater && sourceFetchWater,
      })
      .then((response) => {
        let waterGroup = [];
        response.data.forEach((item) => {
          if (categoryId === 98) {
            // temporary, the object must be changed to water source obj
            waterGroup.push({
              id: item.watersource_id,
              name: item.source_name,
              coordinate: item.coordinate,
            });
          } else if (categoryId === 99) {
            waterGroup.push({
              id: item.receivingwaterbody_id,
              name: item.body_name,
              coordinate: item.coordinate,
            });
          }
        });

        setLoading(false);
        setWaterData(waterGroup);
      })
      .catch((err) => {
        console.log('water fetch error response', err.response);
        console.log('water fetch errmessage', err.message);
        setLoading(false);
      });
  }

  // Fungsi hadle delete sumber/badan air
  function handleDeleteWaterData(waterId) {
    setPostLoading(true);

    axios
      .delete(`${fetchApiused}/${siteId}/${waterId}`)
      .then((response) => {
        console.log(response);
        console.log(response.data);
        fetchWaterData(sourceFetchWaterComp.token);
        // let newWaterVariable = [];
        // waterData.forEach((element) => {
        //   if (waterData.id !== waterId) {
        //     newWaterVariable.push(element);
        //   }
        // });
        // setWaterData(newWaterVariable);
        Swal.fire({
          title: 'Deleted!',
          text: response.data,
          icon: 'success',
          confirmButtonColor: '#006CB7',
        });
        setPostLoading(false);
      })
      .catch((err) => {
        if (err.response) {
          console.log('water delete error response', err.response);
          Swal.fire({
            title: 'Deletion Failed!',
            text: err.response.data,
            icon: 'error',
            confirmButtonColor: '#006CB7',
          });
        } else {
          console.log('water delete errmessage', err.message);
          Swal.fire({
            title: 'Deletion Failed!',
            text: err.message,
            icon: 'error',
            confirmButtonColor: '#006CB7',
          });
        }
        setPostLoading(false);
      });
  }

  useEffect(() => {
    const sourceFetchWater = axios.CancelToken.source();

    fetchWaterData(sourceFetchWater.token);
  }, []);

  return (
    <div className={styles.root}>
      {!waterData ? (
        <LoadingSpinner />
      ) : (
        <>
          <AccordionFieldGroup
            data={waterData}
            categoryId={categoryId}
            handleDeleteWaterData={handleDeleteWaterData}
            postLoading={postLoading}
            setPostLoading={setPostLoading}
            inputListSliced={inputListSliced}
          />
          <Button
            label={
              categoryId === 98
                ? 'Tambah Sumber Air'
                : 'Tambah Badan Penerima Air'
            }
            color="green-white"
            onClick={(e) => {
              e.preventDefault();
              setModalShow(!modalShow);
            }}
            blockBtn
            className={styles.addWaterBtn}
          />
          {/* <InputDropdown
          className={styles.addSourceWaterInput}
          name={`addWaterInput`}
          label={categoryId === 98 ? 'Sumber Air' : 'Badan Penerima Air'}
          // defaultValue={defaultValue}
          options={waterData}
          required={true}
          // setInputValue={setAnswer16}
          onAdditionalButtonClick={() => setModalShow(!modalShow)}
          iconButton={faCirclePlus}
        /> */}
          <hr className={styles.contentDivider} />
          <Button
            className={styles.btnBack}
            label="Back"
            color="white"
            onClick={() => navigate(-1)}
          />
        </>
      )}

      {modalShow && (
        <WaterModal
          categoryId={categoryId}
          setModalShow={setModalShow}
          siteId={siteId}
          fetchWaterData={() => fetchWaterData(sourceFetchWaterComp.token)}
        />
      )}
    </div>
  );
}
